import { useEffect } from 'react';
import styles from './scrollLock.module.less';

export const useScrollLock = (enabled = true): void => {
  useEffect(() => {
    if (enabled && document?.body) {
      const orig = document.body.className;
      document.body.className = `${orig} ${styles.scrollLock}`.trim();
    }

    return (): void => {
      if (enabled && document?.body) {
        const regex = new RegExp(` ?${styles.scrollLock}`, 'g');
        document.body.className = document.body.className.replace(regex, '');
      }
    };
  }, [enabled]);
};
